"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlobalSearchTravelType = exports.GSSType = exports.DATE_FORMAT = exports.SEARCH_STATE_PROP = void 0;
exports.SEARCH_STATE_PROP = '_scst';
exports.DATE_FORMAT = 'yyyy-MM-dd';
var GSSType;
(function (GSSType) {
    GSSType["Hotel"] = "GSS";
    GSSType["Flight"] = "FGSS";
})(GSSType || (exports.GSSType = GSSType = {}));
var GlobalSearchTravelType;
(function (GlobalSearchTravelType) {
    GlobalSearchTravelType["Flight"] = "FLIGHT";
    GlobalSearchTravelType["Hotel"] = "HOTEL";
    GlobalSearchTravelType["Package"] = "PACKAGE";
})(GlobalSearchTravelType || (exports.GlobalSearchTravelType = GlobalSearchTravelType = {}));
//# sourceMappingURL=index.js.map